<template lang="pug">
.payout-settings
  AccountDetails
  Swish.m-t-4
</template>

<script>

import AccountDetails from '@/routes/Settings/PayoutAccountDetails.vue';
import Swish from '@/routes/Settings/PayoutSwish.vue';

export default {
  components: {
    AccountDetails,
    Swish,
  },
  computed: {
    /**
     * Return boolean if the account-country is swedish so they can use Swish
     * @returns {Boolean}
     */
    swishEligible() {
      const country = this.$store.getters['AccountManager/accountCountry'];
      return country.toLowerCase() === 'se';
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
